import {
    BasicController,
    BasicCustomCursor,
    BasicLanguageFontManager,
    BasicModel,
    CommandController,
    CountrySelectComponentEvent,
    GGSCountryController,
    LanguageDataEvent,
    SupportUtil
} from "@goodgamestudios/core";

import { SFConstants } from "../../constants/SFConstants";
import { Poker2Model } from "../../model/Poker2Model";
import { Poker2ChoiceLanguageComponent } from "../Poker2ChoiceLanguageComponent";
import { Poker2Panel } from "./Poker2Panel";

import DisplayObject = createjs.DisplayObject;
import MovieClip = createjs.MovieClip;
import Event = createjs.Event;
import MouseEvent = createjs.MouseEvent;

export class Poker2LanguageSelectionMetaPanel extends Poker2Panel {
    private _languageSelectionComponent: Poker2ChoiceLanguageComponent;

    constructor(disp: DisplayObject) {
        CONSTRUCTOR_HACK;
        super(disp);
    }

    protected init(): void {
        super.init();
        // TODO @HTML5 - Poker2Model.localData.readData();

        // BasicModel.languageData.addEventListener(LanguageDataEvent.XML_LOAD_COMPLETE, this.bindFunction(this.onLanguageXMLLoadComplete));

        if (this.supportBtn) {
            this.supportBtn.visible = this.env.useexternallinks;
            this.supportBtn.addEventListener(MouseEvent.CLICK, this.bindFunction(this.onClick));
        }

        this.initLanguageSelectionComponent();
    }

    private initLanguageSelectionComponent(): void {
        this._languageSelectionComponent = new Poker2ChoiceLanguageComponent(this.langSelectionMc.mc_language);
        this._languageSelectionComponent.addEventListener(CountrySelectComponentEvent.COUNTRY_CHANGED, this.bindFunction(this.onSelectedCountry));
        this._languageSelectionComponent.setDefaultCountry(GGSCountryController.instance.currentCountry);
    }

    private resetLanguageSelectionCombobox(): void {
        if (this._languageSelectionComponent) {
            this._languageSelectionComponent.removeEventListener(CountrySelectComponentEvent.COUNTRY_CHANGED, this.bindFunction(this.onSelectedCountry));
            this._languageSelectionComponent.destroy();
        }

        this.initLanguageSelectionComponent();
    }

    protected get supportBtn(): MovieClip {
        return this.langSelectionMc.btn_mailsupport;
    }

    protected onMouseOver(event: MouseEvent): void {
        super.onMouseOver(event);

        switch (event.currentTarget.name) {
            case "btn_mailsupport":

                event.currentTarget.scaleX = event.currentTarget.scaleY = 1.05;
                if (this.layoutManager.customCursor) {
                    this.layoutManager.customCursor.setCursorType(BasicCustomCursor.CURSOR_CLICK);
                }
                break;

            default:
                if (this.layoutManager.customCursor) {
                    this.layoutManager.customCursor.setCursorType(BasicCustomCursor.CURSOR_CLICK);
                }
        }
    }

    protected onMouseOut(event: MouseEvent): void {
        super.onMouseOut(event);

        switch (event.currentTarget.name) {
            case "btn_mailsupport":
                event.currentTarget.scaleX = event.currentTarget.scaleY = 1;
                if (this.layoutManager.customCursor) {
                    this.layoutManager.customCursor.setCursorType(BasicCustomCursor.CURSOR_ARROW);
                }
                break;

            default:
                if (this.layoutManager.customCursor) {
                    this.layoutManager.customCursor.setCursorType(BasicCustomCursor.CURSOR_ARROW);
                }
        }
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);

        switch (event.currentTarget.name) {
            case "btn_mailsupport":
                SupportUtil.navigateToSupport(BasicModel.instanceProxy.selectedInstanceVO.instanceId, this.env.versionInformation.versionText, "-", -1, -1, GGSCountryController.instance.currentCountry.ggsLanguageCode);
                break;
        }
    }

    public destroy(): void {
        super.destroy();
        this._languageSelectionComponent.removeEventListener(CountrySelectComponentEvent.COUNTRY_CHANGED, this.bindFunction(this.onSelectedCountry));
        this.supportBtn.removeEventListener(MouseEvent.CLICK, this.bindFunction(this.onClick));
        // BasicModel.languageData.removeEventListener(LanguageDataEvent.XML_LOAD_COMPLETE, this.bindFunction(this.onLanguageXMLLoadComplete));
        BasicLanguageFontManager.getInstance().removeEventListener(LanguageDataEvent.FONT_LOAD_COMPLETE, this.bindFunction(this.clearLayoutManager));
    }

    protected update(): void {
        this._languageSelectionComponent.setDefaultCountry(GGSCountryController.instance.currentCountry);
        this.unLockPanel();
    }

    private onSelectedCountry(event: CountrySelectComponentEvent): void {
        if (Poker2Model.localData.readLoginDataLanguage() !== event.selectedCountry.ggsLanguageCode) {
            this.lockPanel();

            Poker2Model.localData.saveLanguageData(event.selectedCountry.ggsLanguageCode);

            CommandController.instance.executeCommand(BasicController.COMMAND_CHANGE_COUNTRY, event.selectedCountry);
        }
    }

    private onLanguageXMLLoadComplete(event: Event): void {
        // BasicModel.languageData.removeEventListener(LanguageDataEvent.XML_LOAD_COMPLETE, this.bindFunction(this.onLanguageXMLLoadComplete));
        // BasicLanguageFontManager.getInstance().addEventListener(LanguageDataEvent.FONT_LOAD_COMPLETE, this.bindFunction(this.clearLayoutManager));
    }

    private clearLayoutManager(event: Event): void {
        // reset language selection combobox
        this.resetLanguageSelectionCombobox();

        BasicModel.smartfoxClient.sendMessage("clg", [GGSCountryController.instance.currentCountry.ggsLanguageCode]);

        // BasicModel.languageData.addEventListener(LanguageDataEvent.XML_LOAD_COMPLETE, this.bindFunction(this.onLanguageXMLLoadComplete));
        BasicLanguageFontManager.getInstance().removeEventListener(LanguageDataEvent.FONT_LOAD_COMPLETE, this.bindFunction(this.clearLayoutManager));
    }

    private get langSelectionMc(): Library.PokerLanguageSelection.PokerLanguageSelection {
        return this.disp as Library.PokerLanguageSelection.PokerLanguageSelection;
    }
}
